module.exports = __webpack_public_path__ + "static/media/cost.5615c1a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/program/cost.jpg
// module id = 1168
// module chunks = 114